/* FormDialogComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./FormDialogRenderer");

class FormDialogComponent extends EventEmitter {
    /**
     * Displays a confirmation message to the user.
     * @param {object} [opts] - Optional parameters.
     * @param {string} [opts.title=undefined] - A Title to present to the user.
     * @param {object} [opts.formData] - Object contianing the information about the formdialog.
     * @param {object} [opts.formData.typeInformation] - The typeInformation to use in the formdialog.
     * @param {object} [opts.formData.pristineValue] - The pristine value to initially set the formdialog to.
     *
     * @param {ActionDefinition} [confirmDetails=undefined] - Details about the confirm action definition.
     * @param {ActionDefinition} [rejectDetails=undefined] - Details about the reject action definition.
     */
    constructor(opts) {
        super();
        this._typeInformation = _.get(opts, "formData.typeInformation", {});
        this._pristineValue = _.get(opts, "formData.pristineValue", {});

        this._title = _.get(opts, "title", "Provide Details");
        this._msg = _.get(opts, "message");
        this._confirmationationDetails = _.defaults({}, _.get(opts, "confirmDetails"), {
            type: "text",
            text: "Yes",
        });
        this._rejectionDetails = _.defaults({}, _.get(opts, "rejectDetails"), {
            type: "text",
            text: "No",
        });

        this._renderer = new Renderer(this);

        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    /* jshint ignore:start */
    set "$teve.ui.context"(cntxt) {
        //jshint ignore:line
        //jshint ignore:line
        this._userFeedbackContext = cntxt;
    }
    /* jshint ignore:end */
    get message() {
        return this.getMessage();
    }
    getMessage() {
        return this._msg;
    }
    get title() {
        return this.getTitle();
    }
    getTitle() {
        return this._title;
    }
    get typeInformation() {
        return this.getTypeInformation();
    }
    getTypeInformation() {
        return this._typeInformation;
    }
    get pristineValue() {
        return this.getPristineValue();
    }
    getPristineValue() {
        return this._pristineValue;
    }
    get confirmationDeets() {
        return this.getConfirmationDeets();
    }
    getConfirmationDeets() {
        return this._confirmationationDetails;
    }
    get rejectionDeets() {
        return this.getRejectionDeets();
    }
    getRejectionDeets() {
        return this._rejectionDetails;
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /* START PUBLIC ACTION METHODS */
    /*******************************************/
    confirm(value) {
        this._userFeedbackContext.resolve(value);
    }
    reject(e) {
        this._userFeedbackContext.reject(e);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = FormDialogComponent;
